import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDtubeComponent } from './simple-icons-dtube.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDtubeComponent ],
    exports:      [ SimpleIconsDtubeComponent ],
    bootstrap:    []
})
export class SimpleIconsDtubeModule {}
